import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
import {
  getHeaders,
  checkStatus
} from "../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL_TICKET;

// For fetching the record of Conversation Service.
export const GetCycleList = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/cycles?StatusFilter=${params.StatusFilter}&Guid=${params.Guid}&Search=${params.Search}&PageNumber=${params.PageNumber}&PageSize=${params.PageSize}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const GetAssessmentCycleById = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/cycles/${params.Guid}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const SaveAssessmentCycle = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/cycles`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const AddCycleQuestion = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/cycles/${params?.CycleId}/questions/bulk`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const getExclusionEmployeeList = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/cycles/${params?.cycleId}/excluded`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getInclusionEmployeeList = async (params) => {

  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (
      key !== "cycleId" &&
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      queryParams.append(key, value);
    }
  });
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/cycles/${params?.cycleId}/included?${queryParams.toString()}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const addEmployeeExclusion = async (cycleId, params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/cycles/${cycleId}/excluded`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const removeEmployeeExclusion = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/included`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const updateEmployeeReviewer = async (cycleId, employeeId, params) => {
  try {
    const response = await axiosInstance.put(`${baseURL}/Performance/cycles/${cycleId}/employees/${employeeId}/reviewers`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getSelfAppraisals = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/my/appraisals`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const GetEmployeeAppraisals = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/appraisals/0?Guid=${params?.Guid }`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const GetTeamAppraisals = async (params) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      queryParams.append(key, value);
    }
  });
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/team/appraisals?${queryParams.toString()}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const GetSkipLevelAppraisals = async (params) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      queryParams.append(key, value);
    }
  });
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/skiplevel/appraisals?${queryParams.toString()}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const GetEmployeeGoals = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/goals/${params?.empId}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const SaveSelfAssessment = async (params, appraisalId) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/appraisals/${appraisalId}/self/submit`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const DraftSaveSelfAssessment = async (params, appraisalId) => {
  try {
    const response = await axiosInstance.put(`${baseURL}/Performance/appraisals/${appraisalId}/self`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const CycleInitiate = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseURL}/Performance/cycles/${params?.id}/initiate`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const CycleReminder = async (params, id) => {

  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/cycles/${id?.id}/reminders`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const GetNormalizationList = async (params) => {

  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (
      key !== "cycleId" &&
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      queryParams.append(key, value);
    }
  });

  try {
    const queryString = queryParams.toString();

    const response = await axiosInstance.get(`${baseURL}/Performance/cycles/${params?.cycleId}/normalization${
  queryString ? `?${queryString}` : ""
}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const CycleCompleted = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseURL}/Performance/cycles/${params?.id}/complete`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const CycleStop = async (params, id) => {
  try {
    const response = await axiosInstance.put(`${baseURL}/Performance/cycles/${id}/stop`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const CycleDelete = async (params) => {
  try {
    const response = await axiosInstance.delete(`${baseURL}/Performance/cycles/${params?.id}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}



export const GetKRAByKpi = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseURL}/Performance/goals/${params?.kraId}`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const SaveKRA = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/goals`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const SaveKRAByKPI = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/goals/${params?.kraId }/kpis`, params, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const GetQuestions = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/cycles/${params?.cycleId}/questions`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const EmployeeCycleReview = async (params, payload) => {
  try {
    const response = await axiosInstance.put(`${baseURL}/Performance/cycles/${params?.cycleId}/employees/${params?.empId}/reviewers`, payload, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const SubmitManagerAppraisal = async (appraisalId, payload) => {


  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/appraisals/${appraisalId}/manager/submit`, payload, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const SaveManagerAppraisal = async (appraisalId, payload) => {


  try {
    const response = await axiosInstance.put(`${baseURL}/Performance/appraisals/${appraisalId}/manager`, payload, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveDefaultReviewers = async (cycleId, payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/cycles/${cycleId}/reviewers/defaults`,
      payload, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {

    return Promise.reject(error);
  }
};

export const resetEmployees = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/cycles/${params.cycleId}/employees/reset`,
      params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {

    return Promise.reject(error);
  }
};

export const sendBackAssessment = async (params, appraisalId) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/appraisals/${appraisalId}/sendback`,
      params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {

    return Promise.reject(error);
  }
};

export const verifyIncludedEmployees = async (cycleId) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/cycles/${cycleId}/verify`, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const SubmitSkipLevelReview = async (appraisalId, payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/appraisals/${appraisalId}/skiplevel/submit`, payload, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {

    return Promise.reject(error);
  }
};

export const SaveSkipLevelReview = async (appraisalId, payload) => {
  try {
    const response = await axiosInstance.put(
      `${baseURL}/Performance/appraisals/${appraisalId}/skiplevel`, payload, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {

    return Promise.reject(error);
  }
};

export const ratingLabelsList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseURL}/Performance/rating-labels`, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const HRNormalization = async (appraisalId, params) => {
  try {
    const response = await axiosInstance.put(
      `${baseURL}/Performance/appraisals/${appraisalId}/normalize`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {

    return Promise.reject(error);
  }
}

export const SendAppraisalNotification = async (appraisalId, params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/appraisals/${appraisalId}/notify`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const SendCycleReminder = async (cycleId, params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/cycles/${cycleId}/remind`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const ReleaseAppraisalResult = async (appraisalId, params) => {

  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/appraisals/${appraisalId}/release`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// Release all appraisal results for a cycle
export const ReleaseCycleResults = async (cycleId, params) => {


  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/cycles/${cycleId}/release`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


export const getAllCycles = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseURL}/Performance/cycles/all`, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const addKra =  async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/goals`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateKra =  async (params, kraId) => {
  try {
    const response = await axiosInstance.put(
      `${baseURL}/Performance/goals/${kraId}`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const DeleteKra =  async ( kraId) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Performance/goals/${kraId}`,  {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


export const addKpi =  async (params, kraId) => {


  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/goals/${kraId}/kpis`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateKpi =  async (params, kpiId ) => {
  try {
    const response = await axiosInstance.put(
      `${baseURL}/Performance/goals/kpis/${kpiId}`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const DeleteKpi =  async (kpiId) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Performance/goals/kpis/${kpiId}`,  {
        headers: await getHeaders()
      });
    checkStatus(response);


    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateProgress =  async (params, kpiId ) => {
  try {
    const response = await axiosInstance.put(
      `${baseURL}/Performance/goals/kpis/${kpiId}/progress`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


export const SaveKraScore = async(appraisalId, kraSnapshotId, params) => {
   try {
    const response = await axiosInstance.put(
      `${baseURL}/Performance/appraisals/${appraisalId}/kras/${kraSnapshotId}/score`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const SaveGoalCycle = async(params) => {
   try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/goals/cycle`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const PublishUnpublish = async( empId, params) => {
   try {
    const response = await axiosInstance.put(
      `${baseURL}/Performance/goals/cycle/employee/${empId}/toggle-publish`, params,  {
        headers: await getHeaders()
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const CarryForward = async( params) => {
   try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/goals/carry-forward`, params, {
        headers: await getHeaders()
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const GetGoalCycles = async (params) => {
   try {
    const response = await axiosInstance.get(
      `${baseURL}/Performance/goals/cycles`,  {
        headers: await getHeaders()
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const CopyPreviousKra = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Performance/goals/carry-forward`, params,  {
        headers: await getHeaders()
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

